export const getCharacterTypeString = state => {
  if (!state) {
    return "[?]";
  }
  return "name" in state ? state.typeString : `[${state.character}]`;
};
//# sourceMappingURL=utils.js.map